module.exports = __webpack_public_path__ + "static/media/img-modal-premium-4.b10fd0b2.png";